/**
* @desc the ngPassengerInfoResume provides support for displaying the information resumed associated with a passenger in the purchase funnel
* @example <div ng-repeat="pax in view.paxes" ng-passenger-info-resume paxinfo="pax" cards="cards" outboundbaggage="view.itineraries[0].baggages" inboundbaggage="view.itineraries[1].baggages" request="view.request"></div>
*/

webClient.directive('ngPassengerInfoResume', ['$window', 'templateService', function ($window, templateService) {
    var directive = {};
    directive.restrict = 'EA';
    directive.scope = {
        paxinfo: "=",
        cards: "=",        
        request: "=",
        triptype: "=",
        itineraries: "=",
        proposalsrequested: "=",
        response: "="
    };
    directive.link = function ($scope, $element) {

        templateService.compile($scope, $element, 'tpl/_BookingPaxsResume.html');
        $scope.hasFlightHotelFormSummary = hasCookie("FlightHotelFormSummary") && $window.getUrlVars()['hotelSummary'] === 'true';
        //Initialize Variables
        $scope.getUrl = $window.getUrl;
        $scope.siteType = $window.site.type;
        $scope.enableBlockAgencyRemarks = $window.enableBlockAgencyRemarks;
        $scope.getTemplateUrl = $window.getTemplateUrl;
        $scope.enableSeatMap = !(typeof $window.accountNumber !== 'undefined' && typeof $window.seatMapAccountNumber !== 'undefined' && $window.accountNumber != $window.seatMapAccountNumber);
        $scope.seatSelection = null;

        function formatDimensions(dimensions) {
            if (!dimensions) return '';
            const dimText = [dimensions.length, dimensions.width, dimensions.height]
                .map(Number)
                .sort((a, b) => b - a)
                .join(' x ');
            return dimText + ` ${dimensions.unit}`
        }

        $scope.updateTemplate = function () {
            $scope.cardName = "";

            if ($scope.paxinfo.fidelityCardType && $scope.cards != null)
            {
                $scope.cards = $scope.cards.groupByKey('reference');
                $scope.cardName = $scope.cards[$scope.paxinfo.fidelityCardType].name;
            }

            //Include Baggages:
            //Dictionary [itineraryKey+PaxType]
            $scope.baggagesbyItinerary = {};

            if ($scope.proposalsrequested.fares) {
                $scope.proposalsrequested.fares.each(function (f) {
                    if (f.paxType == $scope.paxinfo.paxType) {
                        f.itineraries.each(function (fareItinerary) {
                            if (fareItinerary.baggages.length > 0) {
                                fareItinerary.baggages.each(function (bag) {
                                    if (!$scope.baggagesbyItinerary[fareItinerary.key + $scope.paxinfo.paxType]) {
                                        $scope.baggagesbyItinerary[fareItinerary.key + $scope.paxinfo.paxType] = {
                                            itineraryKey: fareItinerary.key
                                        }
                                    }
                                    if (!$scope.baggagesbyItinerary[fareItinerary.key + $scope.paxinfo.paxType][bag.location]) {
                                        $scope.baggagesbyItinerary[fareItinerary.key + $scope.paxinfo.paxType][bag.location] = {
                                            baggages: []
                                        }
                                    }
                                    $scope.baggagesbyItinerary[fareItinerary.key + f.paxType][bag.location].baggages.push({
                                        ...bag,
                                        dimensionsText: formatDimensions(bag.dimensions),
                                        paxType: f.paxType,
                                        include: true
                                    });

                                })
                            }
                        })
                    }
                })
            }

            //Additional baggages:            
            if ($scope.paxinfo.baggageByItinerary) {
                if ($scope.paxinfo.baggageByItinerary.length == undefined) {
                    for (baggageItineraryKey in $scope.paxinfo.baggageByItinerary) {
                        for (var location in $scope.paxinfo.baggageByItinerary[baggageItineraryKey]) {
                            if ($scope.paxinfo.baggageByItinerary[baggageItineraryKey][location].quantity > 0) {
                                if (!$scope.baggagesbyItinerary[baggageItineraryKey + $scope.paxinfo.paxType]) {
                                    $scope.baggagesbyItinerary[baggageItineraryKey + $scope.paxinfo.paxType] = {
                                        itineraryKey: baggageItineraryKey
                                    }
                                }
                                if (!$scope.baggagesbyItinerary[baggageItineraryKey + $scope.paxinfo.paxType][location]) {
                                    $scope.baggagesbyItinerary[baggageItineraryKey + $scope.paxinfo.paxType][location] = {
                                        baggages: []
                                    }
                                }
                                const bag = $scope.paxinfo.baggageByItinerary[baggageItineraryKey][location];
                                $scope.baggagesbyItinerary[baggageItineraryKey + $scope.paxinfo.paxType][location].baggages =
                                    $scope.baggagesbyItinerary[baggageItineraryKey + $scope.paxinfo.paxType][location].baggages.filter(b => b.location != location);
                                $scope.baggagesbyItinerary[baggageItineraryKey + $scope.paxinfo.paxType][location].baggages.push({
                                    ...bag,
                                    dimensionsText: formatDimensions(bag.dimensions),
                                    paxType: $scope.paxinfo.paxType,
                                    include: false,
                                });
                            }
                        }
                    }
                }           
            }

            console.log("aaaa: ", $scope.baggagesbyItinerary)

            if ($scope.enableSeatMap) {
                //Seats
                var purchaseId = $window.$scope.bkgData.purchaseResponse.purchaseId;
                var selectedSeatsKey = 'selectedSeats_' + purchaseId;
            
                var sessionSeats = window.sessionStorage.getItem(selectedSeatsKey);
                if (sessionSeats != null) {
                    var selection = JSON.parse(sessionSeats);
                    $scope.seatSelection = selection;
                    if (paxSeatsIsEmpty($scope.seatSelection)) {
                        $scope.seatSelectionIsEmpty = true;
                    }
                }
            }
            
        };

        function paxSeatsIsEmpty(obj) {
            return Object.values(obj).every(
                value => value && (Object.keys(value).length === 0 || value[$scope.paxinfo.index] == null)
            );
        }

        $scope.updateTemplate();

        $scope.$on("onBookingSummaryUpdate", function (event, args) {
            $scope.updateTemplate();
        });
    };
    return directive;
}]);
